import { Stack, Text  } from '@chakra-ui/react';
import type { StackProps } from '@chakra-ui/react';
import React from 'react';

import { AppRoutes } from '@/constants';
import { NextLinkButton } from '@/modules/navigation';

export const AuthCTA = (props: StackProps) => {
	return (
		<Stack
			bg="white"
			borderRadius="lg"
			boxShadow="sm"
			gap="xs"
			justifyContent="center"
			p={6}
			{...props}
		>
			<Text textAlignLast="center">Don't have an account?</Text>
			<NextLinkButton colorPalette="tertiary" href={AppRoutes.auth.register} size="md" w="full">
				Register (Free)
			</NextLinkButton>
			<NextLinkButton href={AppRoutes.auth.login} size="md" variant="outline" w="full">
				Login here
			</NextLinkButton>
		</Stack>
	);
};
